import Vue from 'vue'

import SelectCart from '@/components/b2b/cart/SelectCart'

Vue.use(SelectCart)
